/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import {
  Center,
  Box,
  Title,
  Button,
  Space,
  Table,
  Group,
  Image,
  Text,
  Stack,
  Divider,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, createSearchParams } from 'react-router-dom';
import QRCode from 'qrcode.react';
import dayjs from 'dayjs';
import { sendRequest, sendRequestWithToken } from '../../services/services';
import Logo from '../../image/hyperthink-logo.png';
import tickMark from '../../image/tick-mark.png';

const PaymentStatus = ({ invoiceDataId, passDataId }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [ticketData, setTicketData] = useState();
  const [invoiceData, setInvoiceData] = useState();
  const [invoiceId, setInvoiceId] = useState();
  const [text, setText] = useState();
  const [checkout, setCheckout] = useState();
  const [mounted, setMounted] = useState(false);
  const [location, setLocation] = useState('');
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const resourcePath = searchParams.get('resourcePath');
  // const passIdData = searchParams.get('passId');
  // const Pass = parseInt(ticketData?.invoices?.id, 10);
  const Pass = parseInt(invoiceDataId, 10);
  const passIdData = passDataId;

  useEffect(() => {
    setMounted(true);
    setLocation(`${window.location.protocol}//${window.location.host}/`);
  }, []);

  // const invoiceFetch = () => {

  // };

  useEffect(() => {
    // invoiceFetch();
    sendRequestWithToken(`payments/invoice/${Pass}`, 'get').then((res) => {
      setInvoiceData(res?.data);
      setInvoiceId(res);
    });
  }, [Pass]);

  const invoicePrint = () => {
    window.print();
    localStorage.removeItem('selectedVas');
    navigate('/');
    window.location.reload();
  };

  useEffect(() => {
    sendRequest(`parking/reservations-by-pass-id/${passIdData}`, 'get').then((res) => {
      setTicketData(res?.data || []);
    });
  }, [passIdData]);

  const now = dayjs();
  const date1 = dayjs(ticketData?.result?.start_time);
  const date2 = dayjs(!ticketData?.result?.end_time ? now : ticketData?.result?.end_time);
  const TotalSeconds = date2.diff(date1, 'minutes');
  const hours = Math.ceil(TotalSeconds / 60);

  const rows = invoiceData?.invoice_items.map((element) => (
    <tr key={element.name}>
      {/* <td>{element.invoice_item_list?.name}</td> */}
      <td>{Number(element?.amount).toFixed(2)}</td>
      <td>{((Number(element?.amount) * Number(15)) / 100).toFixed(2)}</td>
      <td>{Number(element?.unit_price).toFixed(2)}</td>
      <td>{element?.unit}</td>
      <td>
        {element.invoice_item_list?.name === 'Reservation'
          ? 'Parking'
          : element.invoice_item_list?.name}
      </td>
    </tr>
  ));

  const enfoRows = ticketData?.result?.enforcements?.map((em) => (
    <tr key={em?.name}>
      <td>{em?.name}</td>
      <td>{Number(em?.amount).toFixed(2)}</td>
      <td>{em ? 1 : 0}</td>
      <td>
        {Number(em?.amount).toFixed(2)} {t('ticket.amount.sar.text')}
      </td>
    </tr>
  ));
  return (
    <Box>
      <div className="printme">
        <Stack align="center" spacing={0}>
          <Image src={Logo} width={200} py="md" />
          <Group position="apart">
            <Text>{now.format('DD/MM/YY')}</Text>
            <Text>{now.format('hh:mma')}</Text>
          </Group>
          <Text>{ticketData?.site_details?.name}</Text>
          <Text>{ticketData?.result?.sites?.name}</Text>
          <Text>**********************************</Text>

          <Title order={5}>فاتورة ضريبية مبسطة</Title>
          <Title order={5}>Simplified Tax Invoice</Title>
          <Group>
            <Text>{t('payment.status.invoice.print.vat.number.text')}</Text>
            <Text>{ticketData?.result?.sites?.vat_no}</Text>
          </Group>
          <Text>*******************************************</Text>
        </Stack>
        <Stack>
          <Group>
            <Text>Invoice Number:</Text>
            <Text>{invoiceData?.id}</Text>
          </Group>
          <Group>
            <Text>Payment Type:</Text>
            <Text>{invoiceData?.payment_transactions?.[0]?.payment_types?.name}</Text>
          </Group>
        </Stack>
        <Divider my="sm" size="md" color="#0000000" variant="dashed" />

        <Box>
          <Center>
            <Table>
              <thead>
                <tr>
                  <th>
                    <Text weight={700} size="sm">
                      القيمة
                    </Text>
                  </th>
                  <th>
                    <Text weight={700} size="sm">
                      الضريبة
                    </Text>
                  </th>
                  <th>
                    <Text weight={700} size="sm">
                      تكلفة الوحدة
                    </Text>
                  </th>
                  <th>
                    <Text weight={700} size="sm">
                      الكمية
                    </Text>
                  </th>
                  <th>
                    <Text weight={700} size="sm">
                      التفاصيل
                    </Text>
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows} {enfoRows}
              </tbody>
            </Table>
          </Center>
          <Divider my="sm" size="md" color="#0000000" variant="dashed" />

          <Group position="apart">
            <Stack>
              <Text size="md" weight={500}>
                {Number(invoiceData?.total_amount).toFixed(2)}
              </Text>
              <Text size="md" weight={500}>
                {Number(invoiceData?.tax).toFixed(2)}
              </Text>
              <Text size="md" weight={500}>
                {Number(invoiceData?.paid_amount).toFixed(2)}
              </Text>
            </Stack>

            <Stack>
              <Text size="md" weight={700}>
                المجموع الفرعي
              </Text>
              <Text size="md" weight={700}>
                الضريبة ( 15% )
              </Text>
              <Text size="md" weight={700}>
                الإجمالي
              </Text>
            </Stack>
          </Group>
        </Box>
        <Divider my="sm" size="md" color="#0000000" variant="dashed" />
        <Divider
          my="sm"
          size="md"
          label={t('payment.status.invoice.print.invoice.qr.divider.label')}
          labelPosition="center"
          variant="dashed"
        />

        <Center py="xl">
          <QRCode
            value={JSON.stringify({
              ticket_Number: passIdData,
              invoice_Number: invoiceData?.id,
              vat_Number: ticketData?.result?.sites?.vat_no,
            })}
            renderAs="canvas"
          />
        </Center>
        <Center>
          <Text>powered by Mawqfi</Text>
        </Center>
        <Divider
          my="sm"
          size="md"
          label={t('payment.status.invoice.print.invoice.qr.divider.label')}
          labelPosition="center"
          variant="dashed"
        />
      </div>

      <Box className="no-printme">
        <Center>
          <Image src={tickMark} width={100} />
        </Center>

        <Center>
          <Box
            sx={(theme) => ({
              textAlign: 'center',
              padding: theme.spacing.md,
            })}
          >
            <Title order={1} sx={{ color: '#939393' }}>
              {t('payment.status.invoice.payment.success')}
            </Title>

            <Center p="xl">
              <QRCode
                value={`https://demo.website.sp.hyperthings.in/ticket/${passIdData}`}
                renderAs="canvas"
              />
            </Center>
            <Text color="#939393" weight={700} size="xl" py="xs">
              {t('payment.status.invoice.scan.qr.code')}
            </Text>
            <Center py="xl">
              <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                {Pass ? (
                  <Button
                    onClick={() =>
                      navigate({
                        pathname: '/findmycarstation/findmycar',
                        search: createSearchParams({
                          passId: passIdData,
                        }).toString(),
                      })
                    }
                    color="blue"
                    size="xl"
                  >
                    {t('payment.status.invoice.find.my.car.button.text')}
                  </Button>
                ) : null}
                <Button onClick={invoicePrint} color="blue" size="xl">
                  {t('payment.status.invoice.print.invoice.button.text')}
                </Button>
              </Group>
            </Center>
          </Box>
        </Center>
        <Space h="xl" />
        <Space h="md" />
        {/* <PrimaryButton /> */}
      </Box>
    </Box>
  );
};
export default PaymentStatus;
